// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__l4GbG","label":"LabeledBox_label__Z3TrD"};